module.exports = __webpack_public_path__ + "media/images/svg/plus-87be85f54a4723e26212acf7c7bdbd93.svg";